declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer, SaveOTSectionDataRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, SaveFollicularScanDetailRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, SaveTestMedCycleActivitiesRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, SaveFollicularPickupsDetailV2Request, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, UpdateIvfCycleByActivityRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, SaveSingleWellFollicleRequest, SaveOocyteMaturityInfoRequest, SaveOocyteMorphologyInfoRequest, SaveIvfOocyteEmbryoStorageRequest, SaveCycleStatusRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest, OqaDetails, OocyteAbnormalitiesDetails, SpermSourceDetailsController, SpermSourceDetailsRequest, IvfSpermStoreByCodeController, IvfSpermStoreByCodeRequest, SaveSpermDetailsRequest, SaveSemenDataRequest, SaveIvfSpermStoreRequest, SaveSingleWellInseminationInfoRequest, SaveIvfCycleInseminationLogRequest, SaveIvfCycleInseminationInfoRequest, CompleteIvfCycleInseminationRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, IvfCycleInseminationByCycleController, IvfCycleInseminationByCycleRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, SaveSingleEmbryoGradeInfoRequest, SaveEmbryoStoreInfoRequest, ReadyForEmbroTransferRequest, ConvertEmbryoGradingToWellCultureRequest, EmbryosFromStoreController, EmbryosFromStoreRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe, OocyteAbPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbEditOvaryModal } from '../ivfworkbench/editovary.modal';
import { NgbAddScanTestModal } from '../ivfworkbench/addscantest.modal';
import { NgbAddScanMedicineModal } from '../ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from '../ivfworkbench/editscanmedicine.modal';
import { NgbEditScanTestModal } from '../ivfworkbench/editscantest.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { PrintService } from '../../../../services/print.service';
import { NgbSearchProviderModal } from '../ivfworkbench/searchprovider.modal';
import { NgbAddOqaModal } from '../ivfworkbench/addoqa.modal';
import { NgbEditOqaModal } from '../ivfworkbench/editoqa.modal';
import { NgbAddAbnormalOqaModal } from '../ivfworkbench/addabnormaloqa.modal';
import { NgbEditAbnormalOqaModal } from '../ivfworkbench/editabnormaloqa.modal';
import { NgbSearchDonarModal } from './searchdonar.modal';
import { NgbAddInseminationLogModal } from '../ivfworkbench/addinseminationlog.modal';
import { NgbEditInsemiModal } from '../ivfworkbench/editinsemi.modal';
import { NgbEditInseminationLogModal } from '../ivfworkbench/editinseminationlog.modal';
import { NgbEditGradingModal } from '../ivfworkbench/editgrading.modal';
import { NgbEditGradingDayModal } from '../ivfworkbench/editgradingday.modal';
import { NgbEditGradingetModal } from '../ivfworkbench/editgradinget.modal';
import { NgbEditGradingFetDetailModal } from '../ivfworkbench/editgradingfetdetail.modal';

@Component({
    selector: 'gradingedit',
    templateUrl: './gradingedit.modal.html',
    styleUrls: ['./gradingedit.modal.scss']
})

export class NgbGradingEditModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode:number;
    @Input() TemplateName: string;
    @Input() CycleCode: number;
    @Input() FollicularGrowthCode: number;
    @Input() ActivityCode: number;
    //@Input() PatientCode: number;
    @Input() FormattedCode: string;
    @Input() IsShowDetail: boolean = false;
    @Input() SectionSequenceNO: number;
    @Input() SectionTypeCode: number;
    @Input() Date: Date;
    @Input() Sign1: string;
    @Input() Sign2: string;
    @Input() TitleName: string;
    @Input() DOC: number;
    @Input() GradingModel: string;
    @Input() sectionData: SectionData;
    @Input() PatientReportCode: any;
    OvulationTriggerDate: NgbDateStruct;
    public ActivityDate: NgbDateStruct;
    public displayPatientdata: boolean = true;
    public displayscansdata: boolean = false;
    @Input() Eggsourcetype: string;
    public EggSourceType: string;
    ExpiryDate: NgbDateStruct;
    ExpiryDate2: NgbDateStruct;
    OvumPickupdate: NgbDateStruct;
    OvumPlannedPickupDate: NgbDateStruct;
    DateofSampleCollection: NgbDateStruct;
    //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() ServiceCode: number;
    searchTitle: string;
    ScanDate: NgbDateStruct;
    NextScanDate: NgbDateStruct;
    public EggSourceActorCode: number;
    public OvulationtriggerDate: Date;
    //private isvisibleendo: boolean = true;
    public ApiResData: ApiResponseModel;
   // public data: string;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    private isvisible: boolean = true;
    public ActivityCodeNew: number;
    private isvisibleendo: boolean = true;
    public ProvidedName: string;
    public Dateofinsemination: Date;
    
    public ProvidedCode: number;
    public Day: number;
    public month: number;
    public Year: number;
    public length: number;
    public Displaynew: boolean = false;
    public Displayold: boolean = true;
    //public IsSelected: boolean;
    ExtractionDate: NgbDateStruct;
    CurrentSaveSingleEmbryoGradeInfoRequest: SaveSingleEmbryoGradeInfoRequest;
    CurrentSaveIvfOocyteEmbryoStorageRequest: SaveIvfOocyteEmbryoStorageRequest;
    CurrentEditEmbryoStoreInfoRequest: SaveEmbryoStoreInfoRequest;
    CurrentReadyForEmbroTransferRequest: ReadyForEmbroTransferRequest;
    CurrentConvertEmbryoGradingToWellCultureRequest: ConvertEmbryoGradingToWellCultureRequest;
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    SelectedpatientDetails: TreatmentCyclesByActorCodeController;

    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
       // alert("patientsdetails");
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.SelectedpatientDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                   /// this.LoadDSAData();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
      private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, public printService: PrintService,
      private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
      private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter, private filter2: OocyteAbPipe,) { }
  ngOnInit() {
   
    this.ShowService = false;
      this.CurrentSaveSingleEmbryoGradeInfoRequest = new SaveSingleEmbryoGradeInfoRequest();
      this.CurrentSaveSingleEmbryoGradeInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfOocyteEmbryoStorageRequest = new SaveIvfOocyteEmbryoStorageRequest();
      this.CurrentSaveIvfOocyteEmbryoStorageRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentReadyForEmbroTransferRequest = new ReadyForEmbroTransferRequest();
      this.CurrentReadyForEmbroTransferRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentConvertEmbryoGradingToWellCultureRequest = new ConvertEmbryoGradingToWellCultureRequest();
      this.CurrentConvertEmbryoGradingToWellCultureRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentEditEmbryoStoreInfoRequest = new SaveEmbryoStoreInfoRequest();
      this.CurrentEditEmbryoStoreInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.LoadPatients();
     
      this.LoadCycles();
    
      this.LoadSingle();
      this.LoadOqaData();
      this.LoadFET();

      //this.LoadScansData();
      //this.LoadOvaryData();
      
      //this.LoadTestData();
      //this.LoadMedicineData();

  }



    CurrentSingleWellCultureByCycleCodeController: SingleWellCultureByCycleCodeController[];
    CurrentSingleWellCultureByCycleCodeRequest: SingleWellCultureByCycleCodeRequest;
    LoadSingle() {

        this.CurrentSingleWellCultureByCycleCodeRequest = new SingleWellCultureByCycleCodeRequest();
        this.CurrentSingleWellCultureByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentSingleWellCultureByCycleCodeRequest.ConditionalOperator = 10;
        this.CurrentSingleWellCultureByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetSingleWellCultureByCycleCodeController()
    }
    GetSingleWellCultureByCycleCodeController() {
        //this.StartRefreshing();


        this.actorservice.GetSingleWellCultureByCycleCodeController(this.CurrentSingleWellCultureByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentSingleWellCultureByCycleCodeController = this.ApiResData.Result;

                    ////var list = this.CurrentSingleWellCultureByCycleCodeController.filter(
                    ////    function (a) {
                    ////        return a.IsTransFerred == true
                    ////    });

                    ////this.CurrentSingleWellCultureByCycleCodeController = list;

                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                    this.LoadActorCode();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentIvfTreatmentPlanController: IvfTreatmentPlanController;
    PlanDetails: IvfTreatmentPlanController;
    CurrentIvfTreatmentPlanRequest: IvfTreatmentPlanRequest;
    LoadActorCode() {
        this.CurrentIvfTreatmentPlanRequest = new IvfTreatmentPlanRequest();
        this.CurrentIvfTreatmentPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentIvfTreatmentPlanRequest.CycleCode = this.CycleCode;
        this.CurrentIvfTreatmentPlanRequest.ConditionalOperator = 10;
        this.CurrentIvfTreatmentPlanRequest.ActorCode = 0;


        this.GetIvfTreatmentPlanController();
    }

    GetIvfTreatmentPlanController() {
        //this.StartRefreshing();
        //this.spinner.show();

        this.actorservice.GetIvfTreatmentPlanController(this.CurrentIvfTreatmentPlanRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.CurrentIvfTreatmentPlanController = this.ApiResData.Result;
                    this.PlanDetails = this.CurrentIvfTreatmentPlanController[0];
                    
                    this.LoadActorCodedetails();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentTreatmentCyclesByActorCodeController2: TreatmentCyclesByActorCodeController[];
    ActorCodeDetails: TreatmentCyclesByActorCodeController;
    SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

    CurrentTreatmentCyclesByActorCodeRequest2: TreatmentCyclesByActorCodeRequest;
    LoadActorCodedetails() {
        this.CurrentTreatmentCyclesByActorCodeRequest2 = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest2.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest2.ActorCode = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest2.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest2.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest2.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest2.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest2.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController2();
    }

    GetTreatmentCyclesByActorCodeController2() {
        // this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest2)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController2 = this.ApiResData.Result;
                    this.ActorCodeDetails = this.CurrentTreatmentCyclesByActorCodeController2[0];
                    this.Day = new Date(this.ActorCodeDetails.DateOfInsemination).getDate();
                    this.month = new Date(this.ActorCodeDetails.DateOfInsemination).getMonth();
                    this.Year = new Date(this.ActorCodeDetails.DateOfInsemination).getFullYear();
                    //this.Dateofinsemination = this.CurrentTreatmentCyclesByActorCodeController2[0].DateOfInsemination;
                    //this.SelectedActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
                    //this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                    //this.LoadPlan();
                    //this.LoadDSAData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    SelectedEmbryo(l: SingleWellCultureByCycleCodeController, doc: number) {


        this.CurrentSaveSingleEmbryoGradeInfoRequest.CellCount = this.GetCellCount(l, doc); //l.CellCount1;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.Grade = this.GetGrade(l, doc);// l.Grade1;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.DOC = doc;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.Imagecode = this.GetImage(l, doc);//.Image1;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.WellCulture = l.SingleWellCultureCode;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.Remarks = this.GetRemarks(l, doc);// l.Remarks1;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.DiscardedComments = l.DiscardedComments;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.IsDiscarded = l.isDisCarded;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.IsFreeze = l.IsFrozen;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.StrawNo = l.StrawNo;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.Location = l.Location;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.IsTransfer = l.IsTransferrable;
        //this.CurrentSaveSingleEmbryoGradeInfoRequest.Co
        const modalRef = this.modalService.open(NgbEditGradingModal,
            {
                centered: true,
                keyboard: false,
                backdrop: 'static'


            })
        modalRef.componentInstance.Wellno = l.WellNo;
        modalRef.componentInstance.DocumentUrl = this.GetImageUrl(l, doc);
        modalRef.componentInstance.Technique = l.Technique;
        modalRef.componentInstance.oqa = l.OoctyeQuality;
        modalRef.componentInstance.Day = doc;
        modalRef.componentInstance.ImageCodenew = this.GetImage(l, doc);
        modalRef.componentInstance.EmbryoGradeCode = this.GetEmbryoGradeCode(l, doc);

        modalRef.componentInstance.PatientName = this.SelectedpatientDetails.OwnerName;
        modalRef.componentInstance.Cyclenumber = this.SelectedpatientDetails.CycleNo;
        modalRef.componentInstance.ActorCode = this.PlanDetails.PatientActorCode;
        modalRef.componentInstance.CurrentSaveSingleEmbryoGradeInfoRequest = this.CurrentSaveSingleEmbryoGradeInfoRequest;

        modalRef.result.then(x => { this.GetSingleWellCultureByCycleCodeController() })
    }
    GradingCheck() {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {

            this.IsGradingCompleted();

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })
    }

    IsGradingCompleted() {


        console.log('..................');
        // this.StartRefreshing();
        //this.CurrentCompleteIvfCycleInseminationRequest.ConditionalOperator = 3;
        this.CurrentReadyForEmbroTransferRequest.CycleCode = this.CycleCode;
        this.CurrentReadyForEmbroTransferRequest.EnterUserEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        this.CurrentReadyForEmbroTransferRequest.TDay = 1;
        this.CurrentReadyForEmbroTransferRequest.ConditionalOperator = 1;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.ReadyForEmbroTransfer(this.CurrentReadyForEmbroTransferRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.ShowList = true;
                        //this.LoadMedicineData();

                        this.stopRefreshing();
                        this.LoadCycles();
                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    GradingCheckDrop() {
        // alert("Drop");
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false
        }).then(() => {

            this.IsGradingCompletedDrop();

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })
    }

    IsGradingCompletedDrop() {


        console.log('..................');
        // this.StartRefreshing();
        //this.CurrentCompleteIvfCycleInseminationRequest.ConditionalOperator = 3;
        this.CurrentConvertEmbryoGradingToWellCultureRequest.CycleCode = this.CycleCode;
        this.CurrentConvertEmbryoGradingToWellCultureRequest.ConditionalOperator = 10;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.ConvertEmbryoGradingToWellCulture(this.CurrentConvertEmbryoGradingToWellCultureRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        //this.ShowList = true;
                        //this.LoadMedicineData();

                        this.stopRefreshing();
                        this.LoadCycles();
                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    CurrentEmbryosFromStoreController: EmbryosFromStoreController[];

    CurrentEmbryosFromStoreRequest: EmbryosFromStoreRequest;
    LoadFET() {
        this.CurrentEmbryosFromStoreRequest = new EmbryosFromStoreRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentEmbryosFromStoreRequest.ActorCode = this.ActorCode;
        this.CurrentEmbryosFromStoreRequest.DOC = "";
        this.CurrentEmbryosFromStoreRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentEmbryosFromStoreRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetEmbryosFromStoreController();
    }

    GetEmbryosFromStoreController() {
        //this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

        this.actorservice.GetEmbryosFromStoreController(this.CurrentEmbryosFromStoreRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentEmbryosFromStoreController = this.ApiResData.Result;

                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetMaxDOC(l: SingleWellCultureByCycleCodeController): number {
        if (l.DOC1 != null) {
            return l.DOC1
        }
        else if (l.DOC2 != null) {
            return l.DOC2
        }
        else if (l.DOC3 != null) {
            return l.DOC3
        }
        else if (l.DOC4 != null) {
            return l.DOC4
        }
        else if (l.DOC5 != null) {
            return l.DOC5
        }
        else if (l.DOC6 != null) {
            return l.DOC6
        }
        return 0;

    }


    CheckAddGrade(grade: string, discarded: boolean, frozen: boolean, transferrable: boolean, doc: number, maxdoc: number): boolean {

        if (grade == null && !discarded && !frozen && !transferrable) {
            return true
        }
        else if (grade == null && (discarded || frozen || transferrable)) {
            if (doc < maxdoc)
                return true
            else
                return false;
        }
        else
            if (grade != null)
                return false;

        return true;
    }

    CanAddGrade(l: SingleWellCultureByCycleCodeController, gradeNo: number): boolean {
        //this.IsGradingCompleted

        var maxdoc = this.GetMaxDOC(l);

        switch (gradeNo) {

            case 1:
                return this.CheckAddGrade(l.Grade1, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC1, maxdoc);

            case 2:
                return this.CheckAddGrade(l.Grade2, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC2, maxdoc);

            case 3:
                return this.CheckAddGrade(l.Grade3, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC3, maxdoc);

            case 4:
                return this.CheckAddGrade(l.Grade4, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC4, maxdoc);
            case 5:
                return this.CheckAddGrade(l.Grade5, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC5, maxdoc);
            case 6:
                return this.CheckAddGrade(l.Grade6, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC6, maxdoc);
            default:
                return false;
        }

    }
    GetCellCount(l: SingleWellCultureByCycleCodeController, doc: number): number {
        //this.IsGradingCompleted

        //var maxdoc = this.GetMaxDOC(l);

        switch (doc) {

            case 1:
                return l.CellCount1;

            case 2:
                return l.CellCount2;

            case 3:
                return l.CellCount3;

            case 4:
                return l.CellCount4;
            case 5:
                return l.CellCount5;
            case 6:
                return l.CellCount6;
            default:
                return 0;
        }

    }
    GetGrade(l: SingleWellCultureByCycleCodeController, doc: number): string {
        //this.IsGradingCompleted

        //var maxdoc = this.GetMaxDOC(l);

        switch (doc) {

            case 1:
                return l.Grade1;

            case 2:
                return l.Grade2;

            case 3:
                return l.Grade3;

            case 4:
                return l.Grade4;
            case 5:
                return l.Grade5;
            case 6:
                return l.Grade6;
            default:
                return null;
        }

    }
    GetImageUrl(l: SingleWellCultureByCycleCodeController, doc: number): string {
        //this.IsGradingCompleted

        //var maxdoc = this.GetMaxDOC(l);

        switch (doc) {

            case 1:
                return l.DocFriendlyName1;

            case 2:
                return l.DocFriendlyName2;

            case 3:
                return l.DocFriendlyName3;

            case 4:
                return l.DocFriendlyName4;
            case 5:
                return l.DocFriendlyName5;
            case 6:
                return l.DocFriendlyName6;
            default:
                return null;
        }

    }

    GetEmbryoGradeCode(l: SingleWellCultureByCycleCodeController, doc: number): number {
        //this.IsGradingCompleted

        //var maxdoc = this.GetMaxDOC(l);

        switch (doc) {

            case 1:
                return l.D1EmbryoGrade;

            case 2:
                return l.D2EmbryoGrade;

            case 3:
                return l.D3EmbryoGrade;

            case 4:
                return l.D4EmbryoGrade;
            case 5:
                return l.D5EmbryoGrade;
            case 6:
                return l.D6EmbryoGrade;
            default:
                return 0;
        }

    }
    GetImage(l: SingleWellCultureByCycleCodeController, doc: number): number {
        //this.IsGradingCompleted

        //var maxdoc = this.GetMaxDOC(l);

        switch (doc) {

            case 1:
                return l.Image1;

            case 2:
                return l.Image2;

            case 3:
                return l.Image3;

            case 4:
                return l.Image4;
            case 5:
                return l.Image5;
            case 6:
                return l.Image6;
            default:
                return 0;
        }

    }
    GetRemarks(l: SingleWellCultureByCycleCodeController, doc: number): string {
        //this.IsGradingCompleted

        //var maxdoc = this.GetMaxDOC(l);

        switch (doc) {

            case 1:
                return l.Remarks1;

            case 2:
                return l.Remarks2;

            case 3:
                return l.Remarks3;

            case 4:
                return l.Remarks4;
            case 5:
                return l.Remarks5;
            case 6:
                return l.Remarks6;
            default:
                return null;
        }

    }
    GetMaxGrade(l: SingleWellCultureByCycleCodeController): string {
        if (l.Grade6 != null) {
            return l.Grade6
        }
        else if (l.Grade5 != null) {
            return l.Grade5
        }
        else if (l.Grade4 != null) {
            return l.Grade4
        }
        else if (l.Grade3 != null) {
            return l.Grade3
        }
        else if (l.Grade2 != null) {
            return l.Grade2
        }
        else if (l.Grade1 != null) {
            return l.Grade1
        }
        return "";

    }
    SaveTransfered(l: SingleWellCultureByCycleCodeController) {

        this.StartRefreshing();
        //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
        this.CurrentSaveSingleEmbryoGradeInfoRequest.ConditionalOperator = 20;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.IsTransFerred = true;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.CellCount = l.CellCount1;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.DiscardedComments = l.DiscardedComments;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.DOC = l.DOC1;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.Grade = l.Grade1;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.Imagecode = l.Image1;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.IsDiscarded = l.isDisCarded;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.IsFreeze = l.IsFrozen;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.IsTransfer = l.IsTransFerred;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.Location = l.Location;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.Remarks = l.Remarks1;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.WellCulture = l.SingleWellCultureCode
        //this.CurrentSaveSingleEmbryoGradeInfoRequest.Imagecode = this.ValueChangeActorImageController.ActorImageCode;
        this.actorservice.SaveSingleEmbryoGradeInfo(this.CurrentSaveSingleEmbryoGradeInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        // this.ShowService = false;
                        //alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        ///this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        //this.activeModal.close();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        //this.activeModal.close();


                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        // this.activeModal.close();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        //this.activeModal.close();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        //this.activeModal.close();
                        this.stopRefreshing();
                    }
                }
            );
    }
    CurrentIvfOocyteEmbryoStorageByCodeController: Array<IvfOocyteEmbryoStorageByCodeController>;
    CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;

    LoadOqaData() {
        //alert("ScansData")
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfOocyteEmbryoStorageByCodeController();
    }

    GetIvfOocyteEmbryoStorageByCodeController() {
        // this.StartRefreshing();

        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.ActorCode;

        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 20;

        //alert(this.FormattedCode);
        this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;

                    if (this.CurrentIvfOocyteEmbryoStorageByCodeController != null ||
                        this.CurrentIvfOocyteEmbryoStorageByCodeController.length > 0) {

                        this.EmbryoStoreItems = new Array<EmbryoStoreItem>();
                        this.CurrentIvfOocyteEmbryoStorageByCodeController.forEach((v, i, d) => {
                            var item = new EmbryoStoreItem();
                            item.IsSelected = false;
                            //item.Morphology = v.Morphology;
                            item.Grade = v.Grade;
                            item.OocyteEmbryoStorageCode = v.OocyteEmbryoStorageCode;
                            item.Status = v.Status;
                            //item.Morphology = "";
                            item.StorageUnitType = v.StorageUnitType;
                            item.StorageUnitDetails = v.StorageUnitDetails;
                            item.WellNo = v.WellNo;
                            this.EmbryoStoreItems.push(item);
                        });

                    }

                    //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
                    //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

                    //data.forEach((v, i, a) => {
                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
                    //});
                    //for (let index = 0; index < data.length; index++){
                    //    //alert(data[index].SingleWellFollicleCoder);

                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
                    //}
                    //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //   alert(this.FollicularOocyteInfo.TreatmentCycle);
                    //if (this.FollicularScanEndInfo.ScanDate != null) {
                    //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
                    //  if (SValidFrom.getFullYear() > 1900) {
                    //    console.log('this.UpdateDate >1990');
                    //    this.ScanDate = {

                    //      year: SValidFrom.getFullYear(),
                    //      month: SValidFrom.getMonth() + 1,
                    //      day: SValidFrom.getDate()
                    //    }
                    //  }
                    //}
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    EmbryoStoreItems: Array<EmbryoStoreItem>;
    Store() {

        var toFreeze = this.CurrentSingleWellCultureByCycleCodeController.filter(function (v, i, d) {
            return v.IsFrozen == true
        });

        if (this.CurrentIvfOocyteEmbryoStorageByCodeController == null ||
            this.CurrentIvfOocyteEmbryoStorageByCodeController.length == 0) {

            this.EmbryoStoreItems = new Array<EmbryoStoreItem>();
            toFreeze.forEach((v, i, d) => {
                var item = new EmbryoStoreItem();
                item.IsSelected = false;
                item.Grade = this.GetMaxGrade(v);
                item.OocyteEmbryoStorageCode = 0;
                item.WellNo = v.WellNo;
                //item.Morphology = "";
                this.EmbryoStoreItems.push(item);
            });

        }
    }


    onSubmit2(data2: EmbryoStoreItem) {


        if (data2.OocyteEmbryoStorageCode == 0) {
            this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 10;
        }
        else {
            this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 20;
        }
        //  this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 10;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.ActorCode = this.ActorCode;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.ItemType = "EMBRYO";
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.LastUpdateDate = new Date();
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.LastUpdateTime = new Date();
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.Morphology = "";
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.OocyteEmbryoStorageCode = data2.OocyteEmbryoStorageCode;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.Status = "FROZEN";
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.StorageUnitDetails = data2.StorageUnitDetails;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.StorageUnitType = data2.StorageUnitType;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.TreatmentCycle = this.CycleCode;
        this.CurrentSaveIvfOocyteEmbryoStorageRequest.Grade = data2.Grade;

        this.CurrentSaveIvfOocyteEmbryoStorageRequest.WellNo = data2.WellNo;


        this.actorservice.SaveIvfOocyteEmbryoStorage(this.CurrentSaveIvfOocyteEmbryoStorageRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        //this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        //this.LoadInsemination();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );


    }
   
    Editday() {
        const modalRef = this.modalService.open(NgbEditGradingDayModal,
            {
                centered: true,
                backdrop: 'static',
                keyboard: false

            })
    }
    Fetgrading() {
        const modalRef = this.modalService.open(NgbEditGradingetModal,
            {
                centered: true,
                size: "lg",
                backdrop: 'static',
                keyboard: false

            })
        // modalRef.componentInstance.Cyclenumber = this.SelectedpatientDetails.TreatmentCycleCode;
        // modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
        //modalRef.componentInstance.model = "Add";
        modalRef.componentInstance.Cyclenumber = this.CycleCode;

        modalRef.componentInstance.ActorCode = this.ActorCodeDetails.RecepientActorCode;
        modalRef.componentInstance.EggSourceType = this.ActorCodeDetails.EggSourceType;
        modalRef.componentInstance.EggActorCode = this.ActorCodeDetails.EggActorCode;
        modalRef.result.then(x => { this.GetEmbryosFromStoreController() })
    }
    Editfetgrading(l: EmbryosFromStoreController) {
        this.CurrentEditEmbryoStoreInfoRequest.ActorCode = l.ActorCode;
        this.CurrentEditEmbryoStoreInfoRequest.CellStage = l.CellStage;
        this.CurrentEditEmbryoStoreInfoRequest.Count = l.Count;
        this.CurrentEditEmbryoStoreInfoRequest.CreatedUser = AppData.Instance().SelectedBranchCode;;
        this.CurrentEditEmbryoStoreInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentEditEmbryoStoreInfoRequest.CycleCode = l.TreatmentCycle;
        this.CurrentEditEmbryoStoreInfoRequest.Date = l.Date;
        this.CurrentEditEmbryoStoreInfoRequest.DOC = l.DOC;
        this.CurrentEditEmbryoStoreInfoRequest.FetDropletGradingCode = l.FETDropletGradingCode;
        this.CurrentEditEmbryoStoreInfoRequest.Grade = l.Grade;
        this.CurrentEditEmbryoStoreInfoRequest.ReGrade = l.Regrade;
        this.CurrentEditEmbryoStoreInfoRequest.ReGrade2 = l.Regrade2;
        this.CurrentEditEmbryoStoreInfoRequest.Remarks = l.Remarks;


        const modalRef = this.modalService.open(NgbEditGradingFetDetailModal,
            {
                centered: true,
                size: "lg",
                backdrop: 'static',
                keyboard: false

            })
        //modalRef.componentInstance.Cyclenumber = this.SelectedpatientDetails.TreatmentCycleCode;
        modalRef.componentInstance.Date = l.Date;
        modalRef.componentInstance.DOC = l.DOC;
        modalRef.componentInstance.Embryocount = l.Count;
        modalRef.componentInstance.Grade1 = l.Grade;
        modalRef.componentInstance.Grade2 = l.Grade;
        modalRef.componentInstance.Cyclenumber = l.TreatmentCycle;
        modalRef.componentInstance.CurrentEditEmbryoStoreInfoRequest = this.CurrentEditEmbryoStoreInfoRequest;
        modalRef.result.then(x => { this.GetEmbryosFromStoreController() })
    }

    CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
    SemanAnalysis: TreatmentCycleStatusController[];
    SemanAnalysis2: TreatmentCycleStatusController;
    CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetTreatmentCycleStatusController();
    }

    GetTreatmentCycleStatusController() {
        // this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
        //this.spinner.show();
        this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
                    this.SemanAnalysis = this.ApiResData.Result;
                    var Semanlist = this.SemanAnalysis.filter(
                        function (a) {
                            return a.PhaseActivity == "Embryo Grading";
                        });
                    this.SemanAnalysis = Semanlist;
                    this.SemanAnalysis2 = this.SemanAnalysis[0];
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                    this.LoadDSAData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    
    CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
    DSADetails: DSAActivityByCycleCodeController;
    CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

    LoadDSAData() {
       //alert("ScansData")
        this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDSAActivityByCycleCodeController();
    }

    GetDSAActivityByCycleCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
        //this.EggSourceType = this.SelectedpatientDetails.EggSourceType;
        this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.ActorCode;//this.GetActorCode(this.Eggsourcetype);
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
                    this.DSADetails = this.GetCycleActivity2(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
                    //alert(this.DSADetails);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

                    //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
                    //var list = this.CurrentDSAActivityByCycleCodeController.filter(


                    //    function (a) {
                    //        var Date = this.FollicularScanEndInfo.ScanDate;
                    //        var ActorCode = this.SelectedpatientDetails.ActorID;
                    //        return a.ActivityDate == Date && a.ActorCode == ActorCode
                    //    });

                    //this.CurrentDSAActivityByCycleCodeController = list;
                    //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
                    //alert(this.Doc1);
                    //alert(this.Antag);
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    //    GetDsADetails(ActorCode: number, Date: Date) {


    //}
    GetCycleActivity2(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentDSAActivityByCycleCodeController.filter(
            function (v, i, d) {

                return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
            }
        )

    }
    GetActorCode(EggSourceType: string): number {
        // alert("new");
        if (EggSourceType == 'Donor') {
            var DonorActorCode = this.SelectedpatientDetails.EggActorCode;
            return DonorActorCode;
        }
        else if (EggSourceType == 'Self') {
            var OwnerActorCode = this.SelectedpatientDetails.EggActorCode;
            return OwnerActorCode;
        }
    }
    CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
    ActivityCodeInfo: TreatmentCycleActiityMasterController;
    CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

    LoadMasterReq() {
        //alert("ScansData")
        this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCycleActiityMasterController();
    }

    GetTreatmentCycleActiityMasterController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;
                    
                    //this.LoadTestData();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.GetCycleActivity(this.ActorCode, this.ScanDate);

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): TreatmentCycleActiityMasterController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentTreatmentCycleActiityMasterController.filter(
            function (v, i, d) {

                return v.ActorID == ReceipientActorCode && v.DocDate == TransferDateNew;
            }
        )

    }
   
    
   
    

    
   
   
    BackToPatientdata() {
        this.displayPatientdata = true;
        this.displayscansdata = false;
    }
    BackTodashboard2() {
        //this.Showivf = true;
        //this.Showscan = false;
        this.router.navigate(['healins/ivfworkbench']);
    }
    printgrading() {
        this.printService.printDocument("embryograding",
            {
                Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
                TreatmentCycleCodedata: this.CycleCode, ActorCodedata: this.ActorCodeDetails.EggActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
            }
        );
    }
    printgradingdroplet() {
        this.printService.printDocument("embryogradingdroplet",
            {
                Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
                TreatmentCycleCodedata: this.CycleCode, ActorCodedata: this.ActorCodeDetails.EggActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
            }
        );
    }
    printfet() {
        this.printService.printDocument("fet",
            {
                Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
                TreatmentCycleCodedata: this.CycleCode, ActorCodedata: this.ActorCodeDetails.EggActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
            }
        );
    }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

  



}

export class EmbryoStoreItem {

    public OocyteEmbryoStorageCode: number;

    public WellNo: number;
    public StorageUnitType: string;
    public StorageUnitDetails: string;
    public Status: string;

    public Grade: string;
    //public Morphology: string;
    public IsSelected: boolean;
}
